import React from 'react';

import 'spinkit/css/spinkit.css';

export const RotatingPlane = () => (
  <div className="sk-rotating-plane"/>
);

export default RotatingPlane;